import { observable } from "mobx";
import VehicleRegisterVehicleSearchStatus from "./vehicleRegisterVehicleSearchStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleRegisterVehiclesTotalCountResponse {
  @observable
  searchStatus!: VehicleRegisterVehicleSearchStatus;

  /**
   * Total count of vehicles.
   */
  @observable
  totalCount!: number;
}
